"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusEnum = void 0;
let StatusEnum = exports.StatusEnum = /*#__PURE__*/function (StatusEnum) {
  StatusEnum["INFO"] = "INFO";
  StatusEnum["SUCCESS"] = "SUCCESS";
  StatusEnum["ERROR"] = "ERROR";
  StatusEnum["WARNING"] = "WARNING";
  return StatusEnum;
}({});